<template>
  <div>
    <h1 class="text-6xl m-8">404 - page not found</h1>
  </div>
</template>
